export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILURE = 'GET_USERS_FAILURE';
export const SET_FILTER = 'SET_FILTER';



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_list/redux/constants/users.constants.js